import { render, staticRenderFns } from "./aliPayResult.vue?vue&type=template&id=4a6a7ab4&scoped=true&"
import script from "./aliPayResult.vue?vue&type=script&lang=ts&"
export * from "./aliPayResult.vue?vue&type=script&lang=ts&"
import style0 from "./aliPayResult.vue?vue&type=style&index=0&id=4a6a7ab4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a6a7ab4",
  null
  
)

export default component.exports